import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE } from "@/lib/site";
import DisclaimerBanner from "@/components/DisclaimerBanner";

export default function Contact() {
  return (
    <div className="rr-reveal">
      <section className="pt-24 md:pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12">
          <p
            className="text-xs tracking-[0.22em] uppercase mb-6 font-medium"
            style={{ color: "var(--rr-primary)" }}
          >
            Get in touch
          </p>
          <h1
            className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight"
            style={{ color: "var(--rr-text)" }}
            data-testid="contact-title"
          >
            Questions are welcome.
          </h1>
          <p
            className="mt-8 max-w-2xl text-lg leading-relaxed"
            style={{ color: "var(--rr-text-2)" }}
          >
            For inquiries about the course, enrollment, or whether Rewire and Root is the right fit — please reach out by email.
          </p>

          <div
            className="mt-12 pt-10 border-t"
            style={{ borderColor: "var(--rr-border)" }}
          >
            <p
              className="text-xs tracking-[0.2em] uppercase mb-4"
              style={{ color: "var(--rr-primary)" }}
            >
              Email
            </p>
            <a
              href={`mailto:${SITE.email}`}
              data-testid="contact-email-link"
              className="font-serif text-3xl sm:text-4xl md:text-5xl leading-tight rr-link inline-flex items-center gap-3"
              style={{ color: "var(--rr-text)" }}
            >
              <Mail size={26} strokeWidth={1.5} />
              {SITE.email}
            </a>
            <p
              className="mt-6 max-w-xl text-sm leading-relaxed"
              style={{ color: "var(--rr-text-2)" }}
            >
              Please include a short note about your question and any timezone considerations for the live sessions.
            </p>
          </div>

          <div
            className="mt-16 pt-10 border-t grid grid-cols-1 md:grid-cols-3 gap-8 text-sm"
            style={{ borderColor: "var(--rr-border)", color: "var(--rr-text-2)" }}
          >
            <div>
              <p
                className="text-xs tracking-[0.18em] uppercase mb-3"
                style={{ color: "var(--rr-primary)" }}
              >
                Response time
              </p>
              <p>Replies within 2–3 business days.</p>
            </div>
            <div>
              <p
                className="text-xs tracking-[0.18em] uppercase mb-3"
                style={{ color: "var(--rr-primary)" }}
              >
                Not therapy
              </p>
              <p>Please do not include clinical details. This inbox is for course inquiries only.</p>
            </div>
            <div>
              <p
                className="text-xs tracking-[0.18em] uppercase mb-3"
                style={{ color: "var(--rr-primary)" }}
              >
                In crisis?
              </p>
              <p>Please contact a licensed professional in your area or, in an emergency, dial 911.</p>
            </div>
          </div>

          <div className="mt-14">
            <Link
              to="/enroll"
              data-testid="contact-enroll-link"
              className="inline-flex items-center justify-center gap-3 px-8 py-4 text-sm font-medium"
              style={{ background: "var(--rr-primary)", color: "var(--rr-bg)" }}
            >
              Or skip the email — enroll for {SITE.priceLabel}
            </Link>
          </div>
        </div>
      </section>

      <DisclaimerBanner testid="contact-disclaimer-banner" />
    </div>
  );
}
